// BUG-13/BUG-15 fix: أدوات إخفاء جزئي (Masking) للبيانات الحساسة
// تُستخدم لحماية خصوصية أرقام الهواتف والبريد الإلكتروني في الجداول والنوافذ

/**
 * يُخفي منتصف رقم الهاتف ويُظهر أول 3 وآخر 2 أرقام.
 * مثال: 01140158807 => 011****807
 */
export const maskPhone = (phone) => {
  if (!phone) return "—";
  const str = String(phone).trim();
  if (str.length <= 5) return str.replace(/.(?=.)/g, "*");
  const start = str.slice(0, 3);
  const end = str.slice(-3);
  return `${start}${"*".repeat(Math.max(3, str.length - 6))}${end}`;
};

/**
 * يُخفي جزءاً من البريد الإلكتروني: أول حرفين + النطاق.
 * مثال: mohamed@gmail.com => mo****@gmail.com
 */
export const maskEmail = (email) => {
  if (!email) return "—";
  const str = String(email).trim();
  const at = str.indexOf("@");
  if (at < 1) return str;
  const name = str.slice(0, at);
  const domain = str.slice(at);
  const visible = name.slice(0, 2);
  return `${visible}${"*".repeat(Math.max(2, name.length - 2))}${domain}`;
};
